import React from "react";
import { IErrorModel, ITagingDetailModel } from "../type-interface";
import { ILabelValueModel } from "mony-component";
import { TaggingApi } from "../api";

export type TypeTaggingDetailState = {
    state: ILabelValueModel[],
    actions: {
        Load: (keyword: string) => void;
        CreateOtg: (data: ITagingDetailModel, onSuccess: (contactId) => void, onError: (error: IErrorModel[]) => void) => void;
    }
}

export const useTaggingDetailState = (taggingModule: string, taggingGroup: string): TypeTaggingDetailState => {

    const [state, setState] = React.useState([]);

    const Load = React.useCallback(async (keyword: string) => {
        const data = await TaggingApi.FetchHeaderWithoutPaging(keyword, taggingModule, taggingGroup);
        setState(data);
    }, [state]);

    const CreateOtg = React.useCallback(async (data: ITagingDetailModel, onSuccess: (taggingId) => void, onError: (error: IErrorModel[]) => void) => {
        const response = await TaggingApi.CreateDetailOtg(data);
        if (response.success) {
            await Load(data.taggingdet_name);
            onSuccess(response.data.contact_id);
        } else {
            onError(response.messages);
        }
    }, []);

    return {
        state,
        actions: {
            Load,
            CreateOtg
        }
    };
}
